import { Container } from '../../../components/Container'
import { Section } from '../../../components/Section'
import { Steps } from '../../../components/Steps'
import { StepsContent } from '../../../context/StepsContext'
import { InsuranceInfo } from '../../../containers/InsuranceInfo'
import { MeetingRecordSme } from '../../../containers/MeetingRecordSme'

export const Step5 = () => {
  return (
    <Section>
      <Container>
        <StepsContent step={5}>
          <Steps icon="briefcase" />

          <InsuranceInfo />

          <MeetingRecordSme />
        </StepsContent>
      </Container>
    </Section>
  )
}
